import { GET_COURSE_REVIEW, GET_COURSE_REVIEW_FAIL, GET_COURSE_REVIEW_SUCCESS } from '../constants';

// eslint-disable-next-line import/prefer-default-export
export function getCourseReview(id) {
  return {
    types: [GET_COURSE_REVIEW, GET_COURSE_REVIEW_SUCCESS, GET_COURSE_REVIEW_FAIL],
    promise: function promise(fetch) {
      return fetch("/api/course_reviews/".concat(id), {
        method: 'GET'
      });
    }
  };
}